import { StateService } from "./../_services/state.service";
import { CourierService } from "./../_services/courier.service";
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { ProductContent } from "../_models/product-content";
import { ProductPrice } from "../_models/product-price";
import _ from "lodash";
import { Courier } from "../_models/courier";
import { State } from "../_models/state";

@Component({
  selector: "app-view-state-page",
  templateUrl: "./view-state-page.component.html",
  styleUrls: ["./view-state-page.component.scss"],
})
export class ViewStatePageComponent implements OnInit {
  public categories = new FormControl();
  public isDataLoaded = false;
  public isModified = false;
  public newProductContent = new ProductContent();
  public state: State;
  public couriers: Courier[];
  public showAddContents = false;
  public selectedCountry: number = 0;
  public courierTypes = [
    {
      id: "DELIVERY",
      name: "Delivery",
    },
    { id: "PICKUP", name: "Pickup" },
    { id: "CORPORATE", name: "Corporate" },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    public courierService: CourierService,
    public stateService: StateService,
    public globals: Globals,
    private location: Location,
    public snackBar: MatSnackBar,
    public uploadDialog: MatDialog,
    private router: Router
  ) {}

  public activate(): void {
    this.state.active = true;
    this.save();
  }

  public back(): void {
    this.location.back();
  }

  public cancel(): void {
    this.refresh();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public deactivate(): void {
    this.state.active = false;
    this.save();
  }

  public delete() {
    this.stateService.deleteState(this.state.id).subscribe(
      (res) => {
        this.router.navigate(["regional", "states"]);
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public loadData(stateId: number) {
    this.stateService.getState(stateId).subscribe(
      (state) => {
        this.state = state;
        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.showErrorMessage("Courier not found");
        }
      }
    );
  }

  public ngOnInit(): void {
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        this.couriers = couriers;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve couriers");
      }
    );
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const stateId = params.get("id");
          if (!this.globals.isNullOrEmpty(stateId)) {
            this.loadData(parseInt(stateId, 10));
          } else {
            this.showErrorMessage("Please specify the state Id!");
          }

          return Promise.resolve();
        })
      )
      .subscribe();
  }

  public refresh(): void {
    this.isDataLoaded = false;
    this.loadData(this.state.id);
  }

  isStateValid() {
    return this.state.name && this.state.code;
  }

  public save(): void {
    if (!this.isStateValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.stateService.updateState(this.state).subscribe(
      (res) => {
        this.refresh();
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public updateList(price: ProductPrice, propertys: string, value: any) {
    console.log(value);
  }
}
